import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { ActiveAdSpaceInterface } from '../../../interfaces/interfaces';

export const getActiveAdSpacesColumns = (
  setAdSpaceToDelete: (adSpace: ActiveAdSpaceInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
/*   setAdSpaceToToggleActive: (adSpace: ActiveAdSpaceInterface) => void,
  setToggleActiveDialogOpen: (open: boolean) => void, */
  setAdSpaceToUpdate: (adSpace: ActiveAdSpaceInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'adSpaceId', headerName: 'AdSpace ID', width: 100 },
  { field: 'adSpaceOwnerUserId', headerName: 'Owner User ID', width: 120 },
  { field: 'adSpaceRenterUserId', headerName: 'Renter User ID', width: 120 },
  { field: 'adSpaceOwnerPackageId', headerName: 'Owner Package ID', width: 120 },
  { field: 'geoName', headerName: 'Geo Name', width: 150 },
  { field: 'totalAmountToBePaid', headerName: 'Total To Be Paid', width: 130, type: 'number' },
  { field: 'totalAmountPaidSoFar', headerName: 'Paid So Far', width: 120, type: 'number' },
  { field: 'totalAmountRemaining', headerName: 'Remaining', width: 120, type: 'number' },
  { field: 'isFullyPaidToAdSpaceOwner', headerName: 'Fully Paid', width: 100, type: 'boolean' },
  { field: 'weReceivedPayment', headerName: 'We Received Payment', width: 150, type: 'boolean' },
  { field: 'paymentTransactionId', headerName: 'Payment Tx ID', width: 150 },
  { field: 'isVerifiedAtHalfTime', headerName: 'Verified Half', width: 110, type: 'boolean' },
  { field: 'isVerifiedAtHalfTimeDate', headerName: 'HalfTime Date', width: 140 },
  { field: 'isVerifiedAtFullTime', headerName: 'Verified Full', width: 110, type: 'boolean' },
  { field: 'isVerifiedAtFullTimeDate', headerName: 'FullTime Date', width: 140 },
  { field: 'waitingForApproval', headerName: 'Waiting Approval', width: 130, type: 'boolean' },
  { field: 'approvalDate', headerName: 'Approval Date', width: 130 },
  { field: 'waitingForPayment', headerName: 'Waiting Payment', width: 130, type: 'boolean' },
  { field: 'paymentDate', headerName: 'Payment Date', width: 130 },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 150 },
  { field: 'updated_at', headerName: 'Updated', width: 150 },
  { field: 'startDate', headerName: 'Start Date', width: 130 },
  { field: 'endDate', headerName: 'End Date', width: 130 },
/*   {
    field: 'toggleActive',
    headerName: 'Toggle Active',
    width: 130,
    renderCell: (params) => (
      <Button
        color={params.row.active ? 'warning' : 'success'}
        variant="outlined"
        size="small"
        onClick={() => {
          setAdSpaceToToggleActive(params.row);
          setToggleActiveDialogOpen(true);
        }}
      >
        {params.row.active ? 'Deactivate' : 'Activate'}
      </Button>
    ),
    sortable: false,
    filterable: false,
  }, */
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setAdSpaceToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 120,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setAdSpaceToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  }
];